import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/shared.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { ProductVarientService } from './product-varient.service';
@Component({
  selector: 'app-product-varient',
  templateUrl: './product-varient.component.html',
  styleUrls: ['./product-varient.component.scss']
})
export class ProductVarientComponent implements OnInit {
  displayedColumns: string[] = ['SNo', 'variant','variant_code', 'product_category', 'product_model', 'product_color', 'status', 'action'];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);

  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  productVariantForm: FormGroup;
  isLoading: Subject<boolean> = new Subject<boolean>();
  public searchInput = new FormControl("");

  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private productVariantService: ProductVarientService) {
    this.productVariantForm = this.fb.group({
      variant: ['', Validators.required],
      model: ['', Validators.required],
      category: ['', Validators.required],
      color: ['', Validators.required],
      status: ['', Validators.required],
      variantCode:['',Validators.required]
    });
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;
  dropdownSettingsColors = {};
  ngOnInit() {
    this.getList();
    this.getCategory();
    this.getColor();

    this.dropdownSettingsColors = {
      singleSelection: false,
      enableCheckAll: false,
      idField: 'id',
      textField: 'color',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    this.searchInput.valueChanges.subscribe(() => {
      this.applyFilter();
    });
  }

  get f() { return this.productVariantForm.controls; }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    console.log(this.selectedObject);
    
    this.getModel(object?.product_category?.id)
    this.productVariantForm.patchValue({
      variant: object.variant,
      model: object?.product_model?.model,
      category: object?.product_category?.product_category,
      // color: object?.product_color?.color,
      color: this.formatColors(object?.product_color),
      status: object.status ? 1 : 0,
      variantCode:object.variant_code
    })
  }
  formatColors(colors: any[]): string {
    return colors.map(color => color.color).join(', ');
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getList();
  }

  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
  
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const variant = data.variant.toLowerCase().includes(filter);
      const variantCodeMatch = data.variant_code.toLowerCase().includes(filter);
      return variant || variantCodeMatch;
    };
      this.dataSource.filter = filterValue;
  }

  clearSearch() {
    this.searchInput.setValue(''); // Clear the search input
    this.applyFilter();
  }

  create() {
    this.submitted = true
    if (this.productVariantForm.valid) {
      const productVariantData = this.productVariantForm.value;
      let prodColor: string = productVariantData.color
      .map((item: any) => item.id)
      .join(',');
      let obj = {
        "variant": productVariantData.variant,
        "model_id": productVariantData.model,
        "category_id": productVariantData.category,
        "color_id": prodColor,
        'variant_code':productVariantData.variantCode,
        "status": parseInt(productVariantData.status),
        "flag": "create"
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.productVariantService.productVariantCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Product variant created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    // this.submitted = true
    if (this.productVariantForm) {
      const productVariantData = this.selectedObject;
      const productVariantDataStatus = this.productVariantForm.value
      console.log(productVariantData);
      // console.log(this.selectedObject);
      
      
      let prodColor: string = productVariantData.color
        // .map((item: any) => item.id) // Assuming color array items have an 'id' property
        // .join(',');
      let obj = {
        "variant": productVariantData.variant,
        "model_id": productVariantData.model,
        "category_id": productVariantData.category,
        "color_id": prodColor,
        'variant_code':productVariantData.variantCode,
        "status": parseInt(productVariantDataStatus.status),
        "flag": "update",
        "id": productVariantData.id
      }
      console.log(obj);
      
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.productVariantService.productVariantCrud(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Product vairant updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    this.productVariantForm.patchValue({
      variant: '',
      color: [],
      model: '',
      category: '',
      status: '',
      variantCode:''
    });
    this.modelList = [];
  }


  getList() {
    let reqObject = {
      flag: 'list'
    }
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.productVariantService.productVariantCrud(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data
        console.log(this.ELEMENT_DATA);
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  categoryList: any = [];
  getCategory() {
    let reqObject = {
      flag: 'list'
    }
    this.productVariantService.getCategory(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.categoryList = responseData.data
      }
    });
  }

  modelList: any = [];
  getModel(categoryId?: any) {
    this.modelList = []
    let id: any = this.productVariantForm.value.category ? this.productVariantForm.value.category : categoryId
    let reqObject = {
      flag: 'list'
    }
    this.productVariantService.getModel(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.modelList = responseData.data.filter((item: any) => item.category_id == id);
      }
    });
  }

  colorList: any = [];
  getColor() {
    let reqObject = {
      flag: 'list'
    }
    this.productVariantService.getColor(reqObject).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.colorList = responseData.data
      }
    });
  }
}
